import { useState, useEffect, useCallback } from 'react';
import { tcgApi } from '../api/client';
import { PER_PAGE } from '../utils/constants';

export function useTcgCards() {
  const [cards, setCards] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [filters, setFilters] = useState({ language: 'en' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCards = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {
        page,
        per_page: PER_PAGE,
        sort_by: sortBy,
        sort_order: sortOrder,
        ...filters,
      };
      // Remove empty filter values
      Object.keys(params).forEach((key) => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      const response = await tcgApi.listCards(params);
      setCards(response.data.items);
      setTotal(response.data.total);
      setPages(response.data.pages);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to fetch TCG cards');
    } finally {
      setLoading(false);
    }
  }, [page, sortBy, sortOrder, filters]);

  useEffect(() => {
    fetchCards();
  }, [fetchCards]);

  const toggleSort = (column) => {
    if (sortBy === column) {
      setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortBy(column);
      setSortOrder('asc');
    }
    setPage(1);
  };

  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    setPage(1);
  };

  return {
    cards,
    total,
    pages,
    page,
    setPage,
    sortBy,
    sortOrder,
    toggleSort,
    filters,
    updateFilters,
    loading,
    error,
    refresh: fetchCards,
  };
}
